export function formateUAEName(string) {
    if (string == 'UNITED ARAB EMIRATES') {
      return 'UAE';
    } else {
      return string;
    }
  } 